import { IDescriptionElement } from '../types/IDescriptionElement';


export const orthoContent: IDescriptionElement = {
  title: "Nakładki ortodontyczne",
  text: `Marzysz o pięknym, prostym uśmiechu, ale obawiasz się tradycyjnych aparatów ortodontycznych?
         Nakładki na zęby to innowacyjne, wygodne rozwiązanie, które pozwala na korekcję wad zgryzu bez konieczności 
         noszenia widocznych metalowych zamków. Oto wszystko, co powinieneś wiedzieć o tej nowoczesnej metodzie prostowania zębów.`,
  color: 'white',
};